import { render } from "./ViewPartners.vue?vue&type=template&id=6384eca9"
import script from "./ViewPartners.vue?vue&type=script&lang=js"
export * from "./ViewPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__